import {
  SET_IS_IPAD,
  SET_SCREEN_DIMENSIONS,
  SET_HASWEBGL,
  SET_ISMOBILE,
  SET_ISCREENWIDTHSMALL,
  SET_ORIENTATION
} from 'shared/actions/device';

export const initialState = {
  isMobile: false,
  isIPad: false,
  isScreenWidthSmall: false,
  screenHeight: 0,
  screenWidth: 0
};

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_IPAD:
      return {
        ...state,
        isIPad: action.payload
      };
    case SET_ISMOBILE:
      return {
        ...state,
        isMobile: action.payload
      };
    case SET_ISCREENWIDTHSMALL:
      return {
        ...state,
        isScreenWidthSmall: action.payload
      };
    case SET_SCREEN_DIMENSIONS:
      return {
        ...state,
        isPhone: action.payload.isPhone,
        isTablet: action.payload.isTablet,
        isScreenWidthSmall: action.payload.isScreenWidthSmall,
        screenHeight: action.payload.screenHeight,
        screenWidth: action.payload.screenWidth
      };
    case SET_HASWEBGL:
      return {
        ...state,
        hasWebGL: action.payload
      };
    case SET_ORIENTATION:
      return {
        ...state,
        orientation: action.payload
      };
    default:
      return state;
  }
};

export default deviceReducer;
